<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>FILTRAR CUENTAS POR COBRAR</span>
    </div>
    <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
      <template>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="filters.document"
              label="RUC / DNI"
              outlined
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-combobox
              v-model="filters.status"
              label="Estado de deuda"
              :items="status"
              outlined
              hide-details
              clearable
            >
            </v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              ref="customer_id"
              v-model="filters.customer_id"
              :items="customers"
              label="Seleccione cliente"
              outlined
              :item-text="customTextCustomer"
              item-value="id"
              clearable
              :value="filters.customer_id"
              :loading="isLoading"
              v-on:keyup.enter="searchCliente($event)"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-menu
              v-model="menuFrom"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="filters.date_from"
                  label="Desde"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.date_from"
                @input="menuFrom = false"
                no-title
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-menu
              v-model="menuUntil"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="filters.date_until"
                  label="Hasta"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.date_until"
                @input="menuUntil = false"
                no-title
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn
              block
              height="40"
              dark
              color="red"
              @click="handleClearFilters"
            >
              <v-icon size="16" class="mr-1">far fa-trash-alt</v-icon>
              Quitar filtros
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn dark color="blue" block height="40" @click="handleSearch">
              <v-icon size="16" class="mr-1">fas fa-search</v-icon>
              Filtrar datos
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Filters",
  data() {
    return {
      drawer: false,
      menuFrom: false,
      menuUntil: false,
      status: ["PENDIENTE", "PAGADA", "VENCIDO"],
      filters: {
        company_id: null,
        sede_id: null,
        office_id: null,
        ticket: null,
        document: null,
        status: null,
      },
      isLoading: false,
    };
  },
  computed: {
    ...mapState("authentication", ["company_id"]),
    ...mapState("sedes", ["sedes"]),
    ...mapState("customers", ["customers"]),
    ...mapState("offices", ["offices"]),
  },
  methods: {
    ...mapActions("offices", ["getOffices", "run_set_offices"]),
    ...mapActions("sales", ["getOrders"]),
    ...mapActions("debts", ["getDebts"]),
    ...mapActions("customers", ["getCustomers"]),
    show() {
      this.filters.company_id = this.company_id;
      this.drawer = !this.drawer;
    },
    customTextCustomer(item) {
      let text = item.fullname;

      return text;
    },
    customText(item) {
      let text = item.name;

      return text;
    },
    closeForm() {
      this.drawer = false;
    },
    clearData() {
      this.filters.sede_id = null;
      this.filters.office_id = null;
      this.filters.document = null;
      this.filters.ticket = null;
      this.filters.status = null;
    },
    handleClearFilters() {
      this.clearData();
      this.getDebts(this.filters);
    },
    async handleSearch() {
      await this.getDebts(this.filters);
      this.closeForm();
    },
    async searchCliente(event) {
      this.isLoading = true;
      const value = event.target.value;
      if (value.length > 0) {
        await this.getCustomers({ fullname: value });
      } else {
        await this.getCustomers({});
      }
      this.isLoading = false;
    },
  },
};
</script>
